import 'dayjs/locale/tr';
import zod from 'zod-i18n-map/locales/tr/zod.json';

import auth from './auth.json';
import candidate from './candidate.json';
import coach from './coach.json';
import common from './common.json';
import components from './components.json';
import cv from './cv.json';
import interview from './interview.json';
import legal from './legal.json';
import payment from './payment.json';
import survey from './survey.json';

export default {
  auth,
  candidate,
  common,
  components,
  interview,
  coach,
  legal,
  zod,
  cv,
  payment,
  survey,
} as const;
